import {
    AutogenModelSegAllocControl, AutogenRowSegAllocControl, RowSegAllocControlFields
} from "./autogen/AutogenModelSegAllocControl";
import { ConversionUtil } from "@mcleod/core";
import { LMEGeneralSettings } from "@mcleod/general";

export class ModelSegAllocControl extends AutogenModelSegAllocControl<RowSegAllocControl> {
	constructor() {
		super(RowSegAllocControl);
	}
}

export function getSegAllocControlBoolean(field: keyof RowSegAllocControlFields, valueIfNull: boolean = false): boolean {
    const result = getSegAllocControlValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getSegAllocControlValue(field: keyof RowSegAllocControlFields): any {
    return LMEGeneralSettings.getSingleton().getSegAllocControl()[field];
}

export class RowSegAllocControl extends AutogenRowSegAllocControl {
}
